import {
  type Dispatch,
  type SetStateAction,
  createContext,
  useEffect,
  useState,
} from "react";
import { Outlet } from "react-router";

import { SpinnerLoader } from "components/loader/loader";
import { useMultiStepFormState } from "hooks/use-multi-step-form-state";

import { usePropertyUpdateTrampoline } from "./hooks";
import styles from "./property-update-trampoline.module.scss";

export type PropertyUpdateTrampolineContextState = {
  trampoline?: "yes" | "no";
  trampolinePadding?: "yes" | "no";
  confirmNoTrampoline?: boolean;
  files?: FileList;
} | null;

export const PropertyUpdateTrampolineContext = createContext<{
  state: PropertyUpdateTrampolineContextState;
  setState: Dispatch<SetStateAction<PropertyUpdateTrampolineContextState>>;
}>({ state: null, setState: () => null });

export const PropertyUpdateTrampoline = () => {
  const { loading } = usePropertyUpdateTrampoline();

  const { formNavigate, state } =
    useMultiStepFormState<PropertyUpdateTrampolineContextState>(
      PropertyUpdateTrampolineContext
    );

  useEffect(() => {
    if (!state?.trampoline) {
      formNavigate("./");
    }
  }, [formNavigate, state]);

  if (loading) {
    return (
      <div className={styles.loaderWrapper}>
        <SpinnerLoader />
      </div>
    );
  }

  return <Outlet />;
};

export const PropertyUpdateTrampolineFlow = () => {
  const { prevTrampoline } = usePropertyUpdateTrampoline();
  const trampoline = prevTrampoline ? "yes" : "no";
  const [state, setState] = useState<PropertyUpdateTrampolineContextState>({
    trampoline,
    confirmNoTrampoline: false,
  });
  return (
    <PropertyUpdateTrampolineContext.Provider value={{ state, setState }}>
      <PropertyUpdateTrampoline />
    </PropertyUpdateTrampolineContext.Provider>
  );
};
